export default __webpack_public_path__ + "static/media/location-icon.15b8f0c8.svg";